import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { CountUp } from "./shared";
import { IMPACT } from "../../lib/data";
import bg from "../../assets/IMG_6558_2.jpg";

export const Impact = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} id="impact" data-testid="impact-section"
      style={{ position: "relative", overflow: "hidden", color: "#fff", padding: "100px 0" }}>
      <motion.div style={{ position: "absolute", inset: 0, y, zIndex: 0 }}>
        <img src={bg} alt="" aria-hidden="true" style={{ width: "100%", height: "124%", objectFit: "cover" }} />
      </motion.div>
      <div style={{ position: "absolute", inset: 0, zIndex: 1,
        background: "linear-gradient(180deg,rgba(14,14,14,0.85),rgba(14,14,14,0.92))" }} />
      <div className="container" style={{ position: "relative", zIndex: 2 }}>
        <p className="eyebrow center" style={{ color: "var(--gold)", justifyContent: "center", display: "flex" }}>By The Numbers</p>
        <h2 className="section-title" style={{ textAlign: "center", color: "#fff", marginTop: 14 }}>
          The proof is on <span className="accent">the mat</span>
        </h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 30, marginTop: 56 }} className="impact-grid">
          {IMPACT.map((s, i) => (
            <div key={s.label} data-testid={`impact-stat-${i}`}
              style={{ textAlign: "center", borderLeft: i ? "1px solid rgba(255,255,255,0.12)" : "none", padding: "0 8px" }}>
              <CountUp to={s.value} suffix={s.suffix}
                style={{ fontFamily: "'Bebas Neue'", fontSize: "clamp(48px,6vw,76px)", color: "var(--gold)", lineHeight: 1, display: "block" }} />
              <span style={{ fontSize: 13, letterSpacing: "0.1em", textTransform: "uppercase", color: "rgba(255,255,255,0.72)" }}>{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
